import { Worker } from "@react-pdf-viewer/core";
import React, { type ReactNode } from "react";

type ViewerWrapperProps = {
  children: ReactNode;
};

export const ViewerWrapper: React.FC<ViewerWrapperProps> = ({ children }) => (
  <div>
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">{children}</Worker>
  </div>
);
